import { GetObjectCommand, PutObjectCommand } from "@aws-sdk/client-s3";
import { s3Client, BUCKET_NAME, DATA_FILE_KEY } from "./aws-config";
import { initialServices, initialProjects, initialBtsPhotos, initialBtsVideos, initialFounders } from "./initialData";

// Helper to read stream
const streamToString = (stream) =>
    new Promise((resolve, reject) => {
        const chunks = [];
        stream.on("data", (chunk) => chunks.push(chunk));
        stream.on("error", reject);
        stream.on("end", () => resolve(Buffer.concat(chunks).toString("utf8")));
    });

export const fetchData = async () => {
    try {
        const command = new GetObjectCommand({
            Bucket: BUCKET_NAME,
            Key: DATA_FILE_KEY,
        });
        const response = await s3Client.send(command);
        const str = await response.Body.transformToString();
        return JSON.parse(str);
    } catch (err) {
        if (err.name === 'NoSuchKey') {
            console.log("No data file found on S3, using initial data.");
            return {
                services: initialServices,
                projects: initialProjects,
                btsPhotos: initialBtsPhotos,
                btsVideos: initialBtsVideos,
                trailers: [],
                movies: [],
                founders: initialFounders
            };
        }
        console.error("Error fetching data from S3:", err);
        throw err;
    }
};

export const saveData = async (data) => {
    try {
        const command = new PutObjectCommand({
            Bucket: BUCKET_NAME,
            Key: DATA_FILE_KEY,
            Body: JSON.stringify(data),
            ContentType: "application/json",
            CacheControl: "no-cache, no-store, must-revalidate", // Prevent caching issues
        });
        await s3Client.send(command);
        console.log("Data saved to S3 successfully.");
    } catch (err) {
        console.error("Error saving data to S3:", err);
        throw err;
    }
};
